<template>
    <div class="row align-items-center mt-12" v-loading="loading">
        <div class="col-sm-12 col-md-12">
            <el-form ref="formSport" :model="formSport" status-icon :rules="rules" label-position="left">
                <div class="row">
                    <div class="col-sm-6 offset-3">
                        <div class="d-flex align-items-center mb-6" v-if="!modalEdit">
                            <span class="label label-success label-inline mr-2" style="font-size: 1rem;">Deportista</span>
                            <h3 class="text-dark font-weight-bold mb-0">{{currentAcreditation.athlete}}</h3>
                        </div>

                        <el-form-item label="Categoría" label-width="100px" prop="prueba">
                            <el-select v-model="formSport.prueba" multiple  :multiple-limit="4" filterable placeholder="Seleccione una prueba" class="w-100">
                                <el-option v-for="item in karate.test" :key="item.code" :label="item.abrev + ' - ' + item.name" :value="item.code">{{item.abrev}} - {{item.name}}</el-option>
                            </el-select>
                        </el-form-item>
                        <el-alert type="success" :description="karate.message" show-icon></el-alert>
                    </div>
                    

                </div>
            </el-form>

            <el-divider class="my-4"></el-divider>
            <div v-if="modalEdit">
                <div class="btn btn-sm btn-success mr-3" @click="updateSport('formSport')"><i class="el-icon-edit"></i> Actualizar</div>
                <div class="btn btn-sm btn-secondary" @click="cancelEdit"><i class="el-icon-close"></i> Cerrar</div>
            </div>
            <div v-else>
                <div class="btn btn-sm btn-success mr-3" @click="submitSport('formSport')"><i class="el-icon-arrow-right"></i> Siguiente</div>
                <div class="btn btn-sm btn-secondary" @click="cancelProcess"><i class="el-icon-close"></i> Cancelar</div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { STEP, MODAL_NEW, MODAL_EDIT } from "@/store/step.module";
import { RELEASE_ACREDITATION, REGISTER_COMPTETITION, LIST_ACREDITATION, UPDATE_COMPETITION } from "@/store/acreditation.module";
import code from "@/core/config/status.code";

//services
import { wsuService, wsuError } from '@/core/services/wushu.service';

export default {
    props: {
        idacreditation: {
            type: Number,
            default: 0,
        },
        karate: {
            type: Object,
            default: () => {}
        },
        competdata: {
            type: Object,
            default: () => []
        }
    },
    data (){
        return {
            loading: false,
            formSport:{
                idevent: null,
                idsport: null,
                nivel: 'NV',
                prueba: [],
            },
            rules: {
                prueba: [{ required: true, message: 'Falta seleccionar pruebas', trigger: 'change' }]
            }
        }
    },
    computed: {
        ...mapGetters(['modalNew', 'currentAcreditation', 'modalEdit']),
    },
    beforeMount(){
        if(this.modalEdit){
            this.formSport.nivel = this.competdata[0].idniv;
            this.formSport.prueba = [];
            this.competdata.forEach(element => {
                this.formSport.prueba.push(element.idtest);
            });
        }
    },
    methods:{
        submitSport(formName){
            this.$refs[formName].validate((valid) => {
                if (!valid)
                    return false;
                try {
                    this.loading = true;
                    this.$store.dispatch(REGISTER_COMPTETITION,{athlete : this.currentAcreditation, cmp: this.formSport})
                    .then(() => {
                        this.$store.dispatch(LIST_ACREDITATION,{sport: 'karate', data: this.currentAcreditation})
                        .then(() => {
                            this.$store.dispatch(STEP, 4);
                            this.loading = false;
                        })
                        .catch((err) => {
                            console.log('error en la lista de participantes: ' + err);
                        });
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$alert( err.data !='' ? err.data.messages.error : err.statusText, 'Lo sentimos, error: ' + err.status, {
                            type: 'error',
                            confirmButtonText: 'Entendido',
                            callback: action => {
                                this.loading = false;
                                code.Manager(err.status, 'athlete');
                            }
                        });
                    })
                } catch (error) {
                    console.log(error);
                }
            });
        },
        updateSport(formName){
            this.$refs[formName].validate((valid) => {
                if (!valid)
                    return false;
                try {
                    this.loading = true;
                    this.$store.dispatch(UPDATE_COMPETITION,{slug : this.idacreditation, data: this.formSport})
                    .then(() =>{
                        this.loading = false;
                        this.$notify.success({title: 'Perefcto', message: 'Datos de competencia actualizados correctamente.'});
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$alert( err.data !='' ? err.data.messages.error : err.statusText, 'Lo sentimos, error: ' + err.status, {
                            type: 'error',
                            confirmButtonText: 'Entendido',
                            callback: action => {
                            if(err.status == 401)
                                this.$router.push({ name: "login" });
                            }
                        });
                    });
                } catch (error) {
                    console.log(error);
                }
            });
        },
        cancelProcess(){
            this.$confirm('Esto anulará el proceso de registro. Desea continuar?', 'Alerta', {
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                closeOnClickModal: false,
                type: 'warning'
            }).then(() => {
                try {
                    this.loading = true;
                    this.$store.dispatch(RELEASE_ACREDITATION, this.currentAcreditation.idacreditation)
                    .then((mea) => {
                        console.log(mea);
                        this.$store.dispatch(STEP, 0).then(()=>{
                            this.loading = false;
                            this.$store.dispatch(MODAL_NEW, false);
                        });
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$alert( err.data !='' ? err.data.messages.error : err.statusText, 'Lo sentimos, error: ' + err.status, {
                            type: 'error',
                            confirmButtonText: 'Entendido',
                            callback: action => {
                                this.$store.dispatch(STEP, 0).then(()=>{
                                    this.loading = false;
                                    this.$store.dispatch(MODAL_NEW, false);
                                });
                                code.Manager(err.status, 'athlete');
                            }
                        });
                    })
                    
                } catch (error) {
                    this.loading = false;
                    this.$notify.error({title: 'Error:', message: error});
                }
            }).catch(() => {});
        },
        cancelEdit(){
            this.$store.dispatch(MODAL_EDIT, false);
        },
    },
    created(){
        if(this.modalEdit)
            this.formSport.nivel = this.competdata[0].idniv; 
    }
}
</script>